import { render, staticRenderFns } from "./cust-detail-review.vue?vue&type=template&id=36bc35d8&scoped=true"
import script from "./cust-detail-review.vue?vue&type=script&lang=js"
export * from "./cust-detail-review.vue?vue&type=script&lang=js"
import style0 from "./cust-detail-review.vue?vue&type=style&index=0&id=36bc35d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bc35d8",
  null
  
)

export default component.exports